<template>
    <modal :show="true" :show-close="true" @close="$emit('close')" style="min-height: 300px;">
        <template slot="header">
            <h5 class="modal-title">Call Map</h5>
        </template>
        <template>
            <div v-if="loading.flow" class="loading">
                <div class="text-center" style="font-size: 5rem;">
                    <font-awesome-icon :icon="['fal','spinner-third']"
                                       spin></font-awesome-icon>

                </div>
                <div class="text-center">
                    <span style="font-size: 2em;">Loading the map..</span>
                </div>

            </div>
            <table v-if="loading.flow === false"
                   class="table table-striped">
                <thead>
                <tr>
                    <th>Date</th>
                    <th>Duration</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="detail in flow">
                    <td> {{ moment(detail.starttime).format('LLL') }}</td>
                    <td>
                        <span> {{ moment.duration(detail.duration,'seconds').format("h [hrs], m [min], s [sec]") }}</span>
                    </td>
                    <td><span>{{ detail.destination }}</span></td>
                </tr>
                </tbody>
            </table>

        </template>


        <template slot="footer">
            <base-button type="secondary" @click.native="$emit('close')">Close</base-button>
        </template>
    </modal>
</template>
<script>
    import Modal from "../../../components/Modal";
    import axios from "axios";

    export default {
        name: 'CallFlowModal',
        components: {
            Modal,
        },
        props: ['call_id', 'student_id'],
        data() {
            return {
                flow: null,
                loading: {
                    flow: true,
                },
            }
        },
        mounted() {
            this.loadFlow();
        },
        methods: {
            loadFlow() {
                this.$set(this.loading, 'flow', true);
                return axios({
                    url: this.baseAPIURL + 'student/' + this.student_id + '/call/' + this.call_id + '/map',
                    method: 'GET',
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                    },
                }).then(resp => {
                    this.flow = resp.data.data;
                }).finally(() => {
                    this.$set(this.loading, 'flow', false);
                });
            },
        }
    }
</script>
<style scoped>
    .loading {
        z-index: 2;
        margin: -15px;
        margin-top: -48px;
        height: 100%;
        width: 100%;
    }

    .loading:before {
        content: '';
        height: 100%;
        display: inline-block;
        vertical-align: middle;
    }

    .loading > div {
        display: inline-block;
        vertical-align: middle;
        width: 100%;
    }
</style>
